<template>
  <div class="payment-result success">
    <div class="container text-center py-5">
      <h2 class="text-success">✅ Paiement réussi !</h2>
      <p>Merci pour votre commande. Votre paiement a bien été validé.</p>
      <button class="btn btn-orange mt-3" @click="goToOrder">
        Voir ma commande
      </button>
    </div>
  </div>
</template>

<script>
import { useCheckoutStore } from "@/stores/useCheckoutStore";
import { getOrderDetails } from "@/api/orders";

export default {
  name: "PaymentSuccess",
  props: ["orderToken"],
  async mounted() {
    // On recharge les infos de commande (utile après retour Mollie)
    const checkoutStore = useCheckoutStore();
    try {
      const order = (await getOrderDetails(this.orderToken)).data;
      checkoutStore.setOrder(order);
      
    } catch (e) {
      console.error("Impossible de récupérer la commande :", e);
    }
  },
  methods: {
    goToOrder() {
     this.$router.push({ 
    name: "paiement",
    params: this.orderToken  
    });
    },
  },
};
</script>

<style scoped>
.text-success {
  color: #28a745;
}
.btn-orange {
  background-color: #ec621a;
  color: white;
  border-radius: 76px;
  font-size: 18px;
  font-weight: bold;
  padding: 10px 20px;
}
</style>
